import React from 'react';
import { Container } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { useRecoilValueLoadable } from 'recoil';
import { getCart } from '../stateAtoms/cart';
import ResursLogo from './ResursLogo';
import Cart from './Cart';
import Checkout from './Checkout';
import NotFound from './NotFound';
import CartHeader from './CartHeader';

function Main({ country }) {
  const { checkoutId } = useParams();
  const { state, contents } = useRecoilValueLoadable(getCart(checkoutId));
  if (!checkoutId) {
    return <NotFound />;
  }
  return (
    <Container style={{ maxWidth: 600 }}>
      <section className={'py-3'}>
        <ResursLogo />
      </section>
      {state === 'hasError' ? (
        <NotFound />
      ) : (
        <>
          <CartHeader checkoutId={checkoutId} />
          <section className="bg-gray-100 py-4 px-0 mb-4">
            <Cart id={checkoutId} state={state} contents={contents} />
          </section>
          <Checkout id={checkoutId} country={country} />
        </>
      )}
    </Container>
  );
}

export default Main;
